module.exports = __webpack_public_path__ + "img/Ostsee.228dc438.jpg";